import { Box } from "@mui/material";

const style = () => {
  return {
    padding: "12px",
    background: "#FFFFFF",
    border: "1px solid rgba(179, 179, 179, 0.25)",
    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
    borderRadius: "10px",
  };
};

const Card = ({ children }) => {
  return (
    <Box className="card" sx={() => style()}>
      {children}
    </Box>
  );
};

export default Card;
